import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { approverSorter, weekSorter } from '../utils/sorting';
import roles from '../utils/roles';

import Spinner from './Spinner';
import WeekPill from './WeekPill';

import approvedHourActions from '../actions/approvedHourActionCreators';

require.ensure([], () => {
    require('./PMO.less');
});

class PendingApprovals extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            activeManager: "",
            activeWeek: null
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.currentUser) {
            //way to transition to root using react-router if user has no roles
            if(!roles.userHasAnyOfRoles(nextProps.currentUser, ['PMO'])) {
                browserHistory.push('/');
            }
        }
    }

    componentDidMount = () => {
        moment.updateLocale('en', {
            week: { doy: 4 }
        });

        this.props.dispatch(approvedHourActions.pmoLoadApprovable(true));
    }

    // EVENT HANDLERS

    handleManagerClick = (managerName) => { this.setState({ activeManager: this.state.activeManager === managerName ? "" : managerName }); }

    handleWeekClick = (week) => { this.setState({ activeWeek: this.state.activeWeek === week ? null : week }); }

    // RENDER METHOD

    render = () => {

        if (!this.props.loading && this.props.approvableHours.length === 0) {
            return (
                <div className="container">
                    <br/><h4 className="text-center">There are no tasks that are approvable in the past weeks</h4>
                </div>
            );
        }

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-lg-offset-2">
                        <div className="project floating-manage">
                            <h3>Approvable hours</h3>
                            <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                                {
                                    this.props.loading
                                    ? <Spinner/>
                                    : <div className="form-horizontal">
                                        {
                                            this.props.sortedApproverKeys.map((approverKey, outerKey) => {
                                                let approver = this.props.assignedApprovers[approverKey];
                                                return (
                                                    <div key={outerKey} className="panel panel-default panel-pmproject" >
                                                        <div className="panel-heading" role="tab" id="headingThree-outer">
                                                            <h4 className="panel-title" style={{backgroundColor : "#AAA"}}>
                                                                <a style={{cursor : "pointer", backgroundColor: approver.age > 2 ? "#7F0000" : ""}} onClick={this.handleManagerClick.bind(this, approver.name)} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                                                                    <span className="acc"><span className={approver.name === this.state.activeManager ? "md-expand-more" : "md-chevron-right"}/></span>
                                                                    { approver.name ? approver.name : "No approver set" }
                                                                    {
                                                                        approver.age === 1
                                                                        ? <span className="pull-right label">up to {approver.age} week old</span>
                                                                        : <span className="pull-right label">up to {approver.age} weeks old</span>
                                                                    }
                                                                </a>
                                                            </h4>
                                                        </div>
                                                        <div id="collapseThree-outer" className={approver.name === this.state.activeManager ? "panel-collapse" : "panel-collapse collapse"} role="tabpanel" aria-labelledby="headingThree">
                                                            <div className="panel-body">
                                                                {
                                                                    approver.sortedWeeks.map((weekKey, innerKey) => {
                                                                        let hours = approver.weeks[weekKey];

                                                                        return <WeekPill
                                                                                    active={approver.name === this.state.activeManager && this.state.activeWeek && this.state.activeWeek === weekKey}
                                                                                    approvableHours={hours}
                                                                                    handleClick={this.handleWeekClick}
                                                                                    id={outerKey * 1000 + innerKey}
                                                                                    key={outerKey * 1000 + innerKey}
                                                                                    week={weekKey}
                                                                                    />;
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PendingApprovals.contextTypes = {
    router: PropTypes.object.isRequired
};

PendingApprovals.propTypes = {
    approvableHours: PropTypes.array,
    assignedApprovers: PropTypes.object,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    loading: PropTypes.bool,
    sortedApproverKeys: PropTypes.array,
};

const mapStateToProps = (state) => {
    let approvableHours = state.approvedHours.approvableHours;

    let assignedApprovers = {};

    let currentTime = moment();
    let currentWeek = currentTime.year() * 52 + currentTime.isoWeek();

    for (let i = approvableHours.length - 1; i >= 0; --i) {
        let approvedHours = approvableHours[i];

        // skip already approved hours

        if (approvedHours.approvedBy || approvedHours.approvedAt) continue;

        // normalize the week number by using the year and number so we can get the difference between
        // any two weeks

        let week = parseInt(approvedHours.week / 100) * 52 + approvedHours.week % 100;
        let age = currentWeek - week;

        // approvable hours which are in the future or fresh (under a week old) we ignore

        if (age === 0 || age < 0) continue;

        // create the object which holds the approver name, age of the oldest week which needs approval and the weeks themselves

        if (!assignedApprovers[approvedHours.assignedApprover]) {
            assignedApprovers[approvedHours.assignedApprover] = { name: approvedHours.assignedApprover, age: 0, weeks: {} };
        }

        // shorten the access

        let assignedApprover = assignedApprovers[approvedHours.assignedApprover];

        // bump the approver max age if it changes

        if (assignedApprover.age < age)
            assignedApprover.age = age;

        // group by weeks

        let weekRange = moment();
        weekRange.year(parseInt(approvedHours.week / 100));
        weekRange.isoWeek(approvedHours.week % 100);
        let weekRangeString = weekRange.format();

        // create array if necessary

        if (!assignedApprover.weeks[weekRangeString])
            assignedApprover.weeks[weekRangeString] = [];

        // add it to the matching week

        assignedApprover.weeks[weekRangeString].push({ user: approvedHours.user, task: approvedHours.taskName, timeTotal: approvedHours.timeTotal, timeOvertime: approvedHours.timeOvertime });
    }

    // sort approvers by surname then name

    let sortedApproverKeys = Object.keys(assignedApprovers);

    sortedApproverKeys.sort(approverSorter);

    // sort weekRanges

    for (let i = sortedApproverKeys.length - 1; i >= 0; --i) {
        let sortedWeeks = Object.keys(assignedApprovers[sortedApproverKeys[i]].weeks);
        sortedWeeks.sort(weekSorter);
        assignedApprovers[sortedApproverKeys[i]].sortedWeeks = sortedWeeks;
    }

    return {
        approvableHours: approvableHours,
        assignedApprovers: assignedApprovers,
        currentUser: state.users.currentUser,
        loading: state.approvedHours.loading,
        sortedApproverKeys: sortedApproverKeys
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PendingApprovals);



/** WEBPACK FOOTER **
 ** ./src/app/components/PendingApprovals.js
 **/